export default __webpack_public_path__ + "static/media/7C.cb6a5b5c.svg";